import { Container, Text } from '@chakra-ui/react'
import { ErrorFallback, withSentryErrorReporting } from '@components/Fallback'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
} from '@lib/permissions'
import { RESOURCE_ID } from '@lib/permissions/Resource'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const readEncodingPresetsPermission = new Permission(
  RESOURCE_ID.encoding_preset,
  Operations.Read
)

const FailOver = ({ error }) => (
  <ErrorFallback title={'Error Loading Encoding Presets'} error={error}>
    <>
      <Text mt={2}>There was an error loading your encoding presets.</Text>
      <Text>
        Try reloading the page or choosing another item from the side menu
      </Text>
    </>
  </ErrorFallback>
)

const EncodingPresetsRoute = () => (
  <Container maxW={'75rem'}>
    <CheckPermissionsWrapper permissions={[readEncodingPresetsPermission]}>
      <Outlet />
    </CheckPermissionsWrapper>
  </Container>
)

export const Route = createFileRoute('/_auth/o/$orgId/encodingPresets')({
  component: EncodingPresetsRoute,
  beforeLoad: () => ({ getTitle: () => 'Encoding Presets' }),
  errorComponent: withSentryErrorReporting(FailOver),
  loader: () => ({
    crumb: 'Encoding Presets',
  }),
})
